import LightingIcon from '@/bundle/shared/components/banner/images/LightingIcon.svg?react';
import { CompletePaymentBlock } from '@/bundle/shared/components/banner/styles';
import { useNavigate } from 'react-router';
import { Banner } from '@/components/Banner/Banner';
import { getAcceptMasterServiceAgreementPath } from '@/bundle/Auth/AdminOnboardingFlow/AcceptMasterServiceAgreementPage/path';
const TRIAL_BANNER_BACKGROUND = 'linear-gradient(90deg, #AAF4EB 0.01%, #C9D5FF 99.99%)';

export const TrialModeBanner = () => {
  const navigate = useNavigate();

  return (
    <Banner background={TRIAL_BANNER_BACKGROUND} icon={<LightingIcon />}>
      Your account is currently in <b>Trial Mode</b> with <b>limited</b> features.{' '}
      <CompletePaymentBlock onClick={() => navigate(getAcceptMasterServiceAgreementPath())}>
        Activate your subscription
      </CompletePaymentBlock>{' '}
      to unlock full platform access.
    </Banner>
  );
};
